// extracted by mini-css-extract-plugin
module.exports = {"selectLanguageCard":"LanguagePage_selectLanguageCard__1bx8a"};